export const privacyContainerStyles = {
  py: { xs: 4, sm: 6 },
  px: { xs: 2, sm: 4 },
  minHeight: { xs: '60vh', sm: '70vh' },
  backgroundColor: 'background.default',
};

export const privacyHeaderStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  mb: 3,
};

export const privacyPageStyles = {
  container: {
    width: '100vw',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa', // Fondo general claro
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  }
};

export const heroSectionStyles = {
  background: {
    background: '#183B56', // Azul marino principal
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
    py: { xs: 6, md: 8 },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `linear-gradient(135deg, #183B56 0%, #1e4060 100%)`,
      zIndex: 1
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-10%',
      right: '-10%',
      width: '40%',
      height: '120%',
      background: 'rgba(255, 255, 255, 0.03)',
      borderRadius: '50%',
      transform: 'rotate(-15deg)',
      zIndex: 2
    }
  },
  content: {
    position: 'relative',
    zIndex: 3,
    maxWidth: '800px',
    mx: 'auto',
    textAlign: 'center',
    px: { xs: 3, md: 4 }
  },
  title: {
    fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' },
    fontWeight: 700,
    mb: 3,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif',
    lineHeight: 1.2
  },
  subtitle: {
    fontSize: { xs: '1rem', md: '1.125rem' },
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: '600px',
    mx: 'auto',
    lineHeight: 1.6
  }
};

export const contentSectionStyles = {
  container: {
    backgroundColor: 'white',
    py: { xs: 4, md: 6 },
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: { xs: '90%', md: '70%' },
      height: '2px',
      background: 'linear-gradient(90deg, transparent 0%, #183B56 50%, transparent 100%)',
      opacity: 0.1
    }
  },
  wrapper: {
    maxWidth: 900,
    mx: 'auto',
    px: { xs: 3, md: 4 }
  }
};

export const privacySectionStyles = {
  container: {
    mb: 5,
    p: 4,
    backgroundColor: '#f8f9fa',
    borderRadius: 3,
    border: '1px solid #e9ecef'
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#183B56',
    mb: 3,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  },
  subtitle: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#183B56',
    mb: 2,
    mt: 3,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  },
  content: {
    color: '#5A7184',
    fontSize: '1rem',
    lineHeight: 1.6,
    mb: 2
  },
  list: {
    mt: 2,
    pl: 3,
    '& li': {
      mb: 1,
      listStyleType: 'disc',
      color: '#5A7184'
    }
  },
  listItem: {
    color: '#5A7184',
    fontSize: '1rem',
    lineHeight: 1.6
  },
  contactInfo: {
    color: '#183B56',
    fontSize: '1rem',
    mb: 1
  },
  link: {
    color: '#EE752F',
    textDecoration: 'none',
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  footer: {
    textAlign: 'center',
    py: 4,
    borderTop: '1px solid #e9ecef',
    mt: 5
  }
}; 